import { HomeOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Result, Button } from "antd";
import { memo } from "react";
import { useNavigate } from "react-router-dom";

const DataUnavailable = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 transition-colors duration-300 ">
      <div className="max-w-md w-full px-6">
        <Result
          status="500"
          title={
            <span className="text-gray-800 dark:text-white text-4xl font-bold">
              400
            </span>
          }
          subTitle={
            <span className="text-gray-600 dark:text-gray-300 text-lg">
              Dữ liệu không khả dụng hiển thị
            </span>
          }
          extra={
            <div className="space-y-3">
              <Button
                type="primary"
                size="large"
                icon={<HomeOutlined />}
                onClick={() => navigate("/dashboard")}
                className="w-full"
                style={{
                  backgroundColor: "var(--primary-color)",
                  borderColor: "var(--primary-color)",
                }}
              >
                Về trang chủ
              </Button>
              <Button
                type="default"
                size="large"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                className="w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                Quay lại
              </Button>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default memo(DataUnavailable);
